module.exports = __webpack_public_path__ + "img/switzerland-colorectal-cancer-male.a2a634cb.png";